// @flow
import * as React from 'react'
import config from 'config'
import type { GeojsonFeature } from 'components/map/component'

type ActiveMunicipalityPathProps = {
  activeMunicipality: number,
  strokeColor?: string,
  pathGenerator: GeojsonFeature => string
}

// Feature Detection for Internet Explorer and Edge, as they don't support
// Drop Shadow Filters.
let filter = {}
if (typeof window.SVGFEDropShadowElement !== 'undefined') {
  filter = {
    filter: 'url(#shadow)'
  }
}

export function ActiveMunicipalityPath ({
  activeMunicipality,
  strokeColor = '#CCC',
  pathGenerator
}: ActiveMunicipalityPathProps): React.Element<'path'> {
  let feature
  // When we have a really large municipality ID, it must be of a Zurich
  // Kreis, and we need to translate between the ID in the data base and the
  // ID in the topojson features
  if (activeMunicipality >= 10000) {
    let id = parseInt(activeMunicipality.toString().substr(-2), 10)
    feature = config.indexedZurichKreise.get(id)
  } else {
    feature = config.indexedMunicipalityFeatures.get(activeMunicipality)
  }

  return (
    <path
      d={pathGenerator(feature)}
      strokeWidth={2}
      vectorEffect='non-scaling-stroke'
      stroke={strokeColor}
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='transparent'
      {...filter}
    />
  )
}
